import { removeCanvasGuidelines } from '@/components/Editor/helpers/Guidelines';
import { FabricCanvas } from '@/components/Editor/types/fabric';
import { ToggleTypes } from '@/types';

export const mouseUp = (
  canvas: FabricCanvas,
  toggle: ToggleTypes,
): void => {
  canvas[toggle]('mouse:up', removeCanvasGuidelines);
};
